'use strict';

module.exports = /* @ngInject */ function ($mdSidenav, $resource, apiConfig) {

	/**
	 * Section types as defined by VSL command "%%getusertype"
	 *
	 * @type {{ADMIN: string, SUPPLIER: string, CLIENT: string}}
	 */
	const SECTION_TYPES = {
		CLIENT: 'client',
		ADMIN: 'admin',
		SUPPLIER: 'supplier'
	};

	const MODULE_NAVIGATION = {
		// client
		'CLIENT_DASHBOARD': 'start.htm',
		'CLIENT_CATALOG': 'catalog/catalog_list.htm',
		'CLIENT_CATALOG_SEARCH': 'search/vs_search.htm',
		'CLIENT_EXPRESS_SHOP': 'my_shop/my_express_shop.htm',
		'CLIENT_DIRECT_ORDER': 'order/forder_create_prodinsert.htm',
		'CLIENT_MY_SHOP': 'my_shop/my_shop_start.htm',
		'CLIENT_FAVOURITES': 'my_shop/my_favourit_main.htm',
		'CLIENT_MY_ORDERS': 'my_shop/my_order/my_order_list.htm',
		'CLIENT_RFQ': 'rfq/rfq_main.htm',
		'CLIENT_MY_ADMIN': 'my_adm/my_admin_main.htm',
		'CLIENT_SYSTEM': 'my_adm/system/system_main.htm',

		// admin
		'ADMIN_DASHBOARD': 'admin/main.htm&SHOW_MAIN_PAGE=1',
		'ADMIN_CLIENTS': 'admin/customer/man_grp_main.htm',
		'ADMIN_SUPPLIERS': 'admin/lieferanten/lief_main.htm',
		'ADMIN_RFQ': 'admin/rfq/rfq_main.htm',
		'ADMIN_ORDERS': 'admin/order/order_main.htm',
		'ADMIN_SHIPPING_NOTIFICATION': 'admin/order/dispatch_list.htm',
		'ADMIN_ORDER_RECEIPTS': 'admin/order/receipt_list.htm',
		'ADMIN_INVOICES': 'admin/order/invoice_list.htm',
		'ADMIN_GENERAL_STATISTICS': 'admin/statistic/statistic_main.htm',
		'ADMIN_CLIENT_STATISTICS': 'admin/statistic/statistic_customer.htm',
		'ADMIN_SUPPLIER_STATISTICS': 'admin/statistic/statistic_supplier.htm',
		'ADMIN_TRANSACTION_STATISTICS': 'admin/statistic/ums_stat_adv.htm',
		'ADMIN_E_CLASS_STATISTICS': 'admin/statistic/statistic_eclass.htm',
		'ADMIN_SYSTEM_GENERAL': 'admin/system/system_main.htm',
		'ADMIN_SYSTEM_ADMINISTRATORS': 'admin/system/admin/admin_main.htm',
		'ADMIN_SYSTEM_PERMISSIONS': 'admin/system/admin/roles_main.htm',
		'ADMIN_SYSTEM_EVENTS': {
			path: 'admin/container.htm',
			iframeRoute: 'admin/events'
		},
		'ADMIN_SYSTEM_USER_LOGS': 'admin/system/events/user_log.htm',
		'ADMIN_SYSTEM_LANGUAGES': 'admin/languages/add_language.htm',
		'ADMIN_SYSTEM_SETTINGS': 'admin/system/prefs/prefs_admin.htm',
		'ADMIN_SYSTEM_EXPORT': 'admin/database/database_im-export.htm',
		'ADMIN_SYSTEM_NEWSLETTER': 'admin/promotion/mail_main.htm',
		'ADMIN_SYSTEM_NEWS': 'admin/promotion/news_main.htm',

		// supplier
		'SUPPLIER_DASHBOARD': 'supplier/main.htm',
		'SUPPLIER_RFQ': 'supplier/rfq/rfq_main.htm',
		'SUPPLIER_ORDERS': 'supplier/order/order_main.htm',
		'SUPPLIER_DELIVERY_RECEIPTS': 'supplier/order/receipt_list.htm',
		'SUPPLIER_INVOICES': 'supplier/order/invoice_main.htm',
		'SUPPLIER_CATALOG_GENERAL': 'supplier/catalog/catalog_main.htm',
		'SUPPLIER_CATALOG_BME_CAT_IMPORT': 'supplier/catalog/bmecat/main.htm',
		'SUPPLIER_CATALOG_SEARCH': 'supplier/catalog/cat_search/cat_search.htm',
		'SUPPLIER_CATALOG_WAREHOUSE': 'supplier/catalog/storage/storage_main.htm',
		'SUPPLIER_CUSTOMER': 'supplier/customer/cust_grp_main.htm',
		'SUPPLIER_STATISTICS_GENERAL': 'supplier/statistic/statistic_main.htm',
		'SUPPLIER_STATISTICS_CLIENT': 'supplier/statistic/ums_stat_adv.htm',
		'SUPPLIER_SETTINGS_GENERAL': 'supplier/system/system_main.htm',
		'SUPPLIER_SETTINGS_ADMIN_ROLES': 'supplier/system/roles_main.htm',
		'SUPPLIER_SETTINGS_RFQ': 'supplier/config/prefs_rfq.htm',
		'SUPPLIER_SETTINGS_COMPANY_INFO': 'supplier/config/identity/prefs_company.htm',
		'SUPPLIER_SETTINGS_TEXT_MODULES': 'supplier/config/textbricks_main.htm',
		'SUPPLIER_SETTINGS_STAFF': 'supplier/staff/staff_main.htm'
	}

	/**
	 * Id of sidenav element
	 */
	let mobileNavId = 'mobile-sidenav';

	let logo;
	let headerText;
	let section;

	/**
	 * Toggles the sidenav
	 */
	function toggleSideNav() {
		if(mobileNavId){
			$mdSidenav(mobileNavId).toggle();
		}
	}

	function getNavigationItems(){
		return $resource(
			`${apiConfig.$get().apiUrl}/navigation?module=MAIN_NAVIGATION`,
			{},
			{
				query: {
					method: 'GET',
					isArray: true
				}
			}
		)
	}

	return {
		mobileNavId,
		getModuleNavigation: (module) => MODULE_NAVIGATION[module],
		getNavigationItems: getNavigationItems(),
		toggleSidenav: toggleSideNav,
		getLogo: () => logo,
		getHeaderText: () => headerText,
		getSection: () => section,
		SECTION_TYPES,
		setHeaderText: (text) => headerText = text,
		setSection: (currentSection) => section = currentSection,
		setLogo: (src) => logo = src
	}
}
